import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from './shared/session.service';
import { forkJoin, of } from 'rxjs';
import { catchError, take, timeout } from 'rxjs/operators';
import { Account } from './shared/models';

@Injectable({ providedIn: 'root' })
export class TranslationBootstrapperService {
  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private sessionService: SessionService
  ) {}

  async init(): Promise<void> {
    const languageKey = this.sessionService.locale || 'en';
    const account = await this.sessionService.account.pipe(
        take(1),
        timeout(1500),
        catchError(() => of(null))
      )
      .toPromise();

    const productKey = this.getProductKey(account);
    const productTranslations$ = productKey
      ? this.http.get<any>(`assets/i18n/overrides/${languageKey}.${productKey}.json`).pipe(catchError(() => of({})))
      : of({});

    const basePath = `assets/i18n/${languageKey}.json`;
    const baseTranslations$ = this.http.get<any>(basePath).pipe(catchError(() => of({})));

    const [baseTranslations, productTranslations] = await forkJoin([
      baseTranslations$,
      productTranslations$
    ]).pipe(take(1)).toPromise();

    this.translate.setTranslation(languageKey, baseTranslations, false);
    this.translate.setTranslation(languageKey, productTranslations, true); // Overrides the base translations
    this.translate.setDefaultLang(languageKey);
    await this.translate.use(languageKey).pipe(take(1)).toPromise();
  }

  private getProductKey(account: Account): string | null {
    let productKey;
    if (account && !account.hasFeature('seo') && account.hasFeature('starterseo'))
    {
      productKey = 'starterseo';
    }

    return productKey;
  }
}
